import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';

import {MyApp} from './app.component';
import {ComponentsModule} from "../components/components.module";
import {ApiProvider} from '../providers/api/api';
import {HttpClientModule} from "@angular/common/http";
import {DataProvider} from '../providers/data/data';
import {BaseRfcPage} from "../pages/base/baseRfcPage";
import {OfflineModeProvider} from '../providers/offline-mode/offline-mode';

@NgModule({
    declarations: [
        MyApp,
        BaseRfcPage
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(MyApp),
        ComponentsModule,
        HttpClientModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp, BaseRfcPage

    ],
    providers: [
        StatusBar,
        SplashScreen,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        ApiProvider,
        DataProvider,
        OfflineModeProvider
    ]
})
export class AppModule
{
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts